import { CategoryType } from 'src/graphql';

export const isDefaultQuestionFlowIntakeValid = (cat: CategoryType): boolean =>
  Boolean(
    cat.displayInVaultTalk ||
    cat.displayInCollaborationToolIntegration ||
    cat.displayInApp,
  );

export const patchCustomQuestionFlowVisibleChannels = (
  cat: CategoryType,
): CategoryType => ({
  ...cat,
  displayInVaultTalk: false,
  displayInCollaborationToolIntegration: false,
  displayInApp: true,
  displayInManualIntake: false,
  displayInOpenReporting: false,
});

export const patchDefaultQuestionFlowVisibleChannels = (
  cat: CategoryType,
  vaultTalkEnabled: boolean,
  slackEnabled: boolean,
  goTogetherEnabled: boolean,
): CategoryType => ({
  ...cat,
  displayInVaultTalk: vaultTalkEnabled,
  displayInCollaborationToolIntegration: slackEnabled,
  displayInApp: true,
  allowGoTogether: goTogetherEnabled ? true : false,
});

export type DefaultFlowIntakeSnapshot = Pick<
  CategoryType,
  | 'displayInVaultTalk'
  | 'displayInCollaborationToolIntegration'
  | 'displayInApp'
  | 'displayInManualIntake'
  | 'displayInOpenReporting'
>;

export const readDefaultFlowIntakeSnapshot = (
  cat: CategoryType,
): DefaultFlowIntakeSnapshot => ({
  displayInVaultTalk: Boolean(cat.displayInVaultTalk),
  displayInCollaborationToolIntegration: Boolean(
    cat.displayInCollaborationToolIntegration,
  ),
  displayInApp: Boolean(cat.displayInApp),
  displayInManualIntake: Boolean(cat.displayInManualIntake),
  displayInOpenReporting: Boolean(cat.displayInOpenReporting),
});

export const mergeCategoryWithDefaultFlowIntakeSnapshot = (
  cat: CategoryType,
  snapshot: DefaultFlowIntakeSnapshot,
): CategoryType => ({
  ...cat,
  displayInVaultTalk: snapshot.displayInVaultTalk,
  displayInCollaborationToolIntegration:
    snapshot.displayInCollaborationToolIntegration,
  displayInApp: snapshot.displayInApp,
  displayInManualIntake: snapshot.displayInManualIntake,
  displayInOpenReporting: snapshot.displayInOpenReporting,
});
